export default class ReactQueryProviderModule {
    provides() {
        return {
            'root-wrappers': [() => require('./withQueryClientProvider').default],
        };
    }
}
